export default __webpack_public_path__ + "static/media/Di_Di_Chan_AHV_In_Moms_We_Trust.8a2f26fa.jpg";